<template>
    <q-dialog v-model="privacy" position="bottom">
        <q-card class="bg-grey-4 text-secondary" dense flat>
            <q-item bordered padding>
                <q-item-section>
                    <q-item-label class="text-center">
                        By using this site you agree to our <a  class="text-primary normal-link" href="/terms-of-use">terms and conditions</a> and our <a class="text-primary normal-link" href="/privacy-policy">privacy policy</a>.
                    </q-item-label>
                </q-item-section>

                <q-item-section side top>
                    <q-btn @click="acceptPrivacy()" dense rounded color="accent" size="xs" dark icon="close">
                        <q-tooltip class="bg-white text-primary">Close</q-tooltip>
                    </q-btn>
                </q-item-section>
            </q-item>
            <q-card-section class="q-mt-none q-pt-none q-mb-xs q-pb-xs text-center">
                <q-btn color="primary" class="square" text-color="white" size="sm" label="Continue" @click="acceptPrivacy()" />
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
export default {
    props: ["privacy"],
    setup(props, context) {
        const acceptPrivacy = () => {
            context.emit('accept-privacy')
        }
        return  { acceptPrivacy }
    },
}
</script>
